import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ProfileTwoUsersIcon = forwardRef<SVGSVGElement, IconProps>(function ProfileTwoUsersIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46255 4.26701C7.67809 4.26701 6.24218 5.66335 6.24218 7.38386C6.24218 9.05886 7.5941 10.4179 9.30099 10.4913C9.4045 10.4843 9.51386 10.484 9.61702 10.4912C11.3222 10.4171 12.675 9.05891 12.6829 7.38257C12.6822 5.66358 11.2388 4.26701 9.46255 4.26701ZM4.93309 7.38386C4.93309 4.96546 6.95318 3 9.46255 3C11.9622 3 13.992 4.96453 13.992 7.38386L13.992 7.3865C13.9818 9.75191 12.0554 11.6798 9.62417 11.7589C9.5951 11.7599 9.566 11.7589 9.53705 11.7561C9.49497 11.7521 9.43208 11.7515 9.37344 11.7567C9.34643 11.759 9.3193 11.7598 9.29219 11.7589C6.86147 11.6798 4.93309 9.75179 4.93309 7.38386Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2749 5.32285C15.2749 4.97298 15.568 4.68935 15.9295 4.68935C17.9853 4.68935 19.6385 6.3003 19.6385 8.27921C19.6385 10.2181 18.0492 11.7968 16.0674 11.8686C16.0321 11.8699 15.9968 11.8684 15.9617 11.8642C15.9486 11.8626 15.922 11.8616 15.8883 11.8652C15.529 11.9038 15.2054 11.6533 15.1655 11.3055C15.1255 10.9578 15.3844 10.6446 15.7437 10.6059C15.8465 10.5949 15.9542 10.5923 16.0604 10.6006C17.323 10.5336 18.3295 9.51945 18.3295 8.27921C18.3295 6.99769 17.2598 5.95636 15.9295 5.95636C15.568 5.95636 15.2749 5.67273 15.2749 5.32285Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.61309 12.4498C11.2959 12.4498 13.0119 12.8585 14.3381 13.7158C15.5301 14.4837 16.2131 15.5602 16.2131 16.7186C16.2131 17.8769 15.5302 18.9553 14.3387 19.7273C13.0084 20.5887 11.2901 21 9.60655 21C7.92331 21 6.20545 20.589 4.87534 19.7279C3.68309 18.9599 3 17.8834 3 16.7249C3 15.5666 3.68286 14.4882 4.87443 13.7162L4.87683 13.7146C6.21074 12.8586 7.93009 12.4498 9.61309 12.4498ZM5.60146 14.7698C4.68191 15.366 4.30909 16.0864 4.30909 16.7249C4.30909 17.3632 4.68175 18.0814 5.6011 18.6734L5.60254 18.6743C6.67231 19.3671 8.12211 19.733 9.60655 19.733C11.0909 19.733 12.5407 19.3671 13.6104 18.6744C14.5309 18.0781 14.904 17.3573 14.904 16.7186C14.904 16.0802 14.5313 15.362 13.612 14.7701L13.611 14.7694C12.5459 14.0809 11.0983 13.7168 9.61309 13.7168C8.12865 13.7168 6.67616 14.0806 5.60146 14.7698Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0015 13.6303C17.0809 13.289 17.4312 13.0747 17.7839 13.1516C18.4728 13.3019 19.149 13.5699 19.7194 13.9909C20.5406 14.5879 21 15.4201 21 16.2994C21 17.1784 20.5409 18.0104 19.7201 18.6074C19.1428 19.0356 18.4563 19.3149 17.7473 19.4578C17.3934 19.5292 17.0468 19.3094 16.973 18.9668C16.8993 18.6243 17.1264 18.2888 17.4803 18.2174C18.0269 18.1072 18.5261 17.8973 18.9257 17.6003L18.9316 17.5959C19.4704 17.2049 19.6909 16.7285 19.6909 16.2994C19.6909 15.8703 19.4704 15.3939 18.9316 15.0028L18.9271 14.9995C18.5379 14.7119 18.0455 14.5074 17.4961 14.3876C17.1435 14.3107 16.922 13.9716 17.0015 13.6303Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
